"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RADIO_NAME = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_style_proptype_1 = __importDefault(require("react-style-proptype"));
const lodash_debounce_1 = __importDefault(require("lodash.debounce"));
const emotion_1 = require("emotion");
const radio_1 = require("./shapes/radio");
const colors_1 = require("./colors");
const utils_1 = require("./utils");
exports.RADIO_NAME = 'CimRadio';
const Radio = (_a) => {
    var { id, name, checked, label, value, disabled, whiteBackground, className, onCheck, onBlur, onFocus, style } = _a, rest = __rest(_a, ["id", "name", "checked", "label", "value", "disabled", "whiteBackground", "className", "onCheck", "onBlur", "onFocus", "style"]);
    const debouncedChange = lodash_debounce_1.default((e, debouncedValue) => {
        onCheck && onCheck(e, debouncedValue);
    }, 200, {
        leading: true,
        trailing: false,
    });
    const handleBlur = e => {
        onBlur && onBlur(e);
    };
    const handleFocus = e => {
        onFocus && onFocus(e);
    };
    const handleChange = e => {
        e.persist();
        debouncedChange(e, value);
    };
    const inputId = utils_1.useMemoizedId({ id, label });
    const backgroundColor = whiteBackground ? colors_1.white : undefined;
    let image;
    if (checked) {
        image = disabled ? react_1.default.createElement(radio_1.Selected, { color: colors_1.alloy, backgroundColor: backgroundColor }) : react_1.default.createElement(radio_1.Selected, { backgroundColor: backgroundColor });
    }
    else {
        image = disabled ? (react_1.default.createElement(radio_1.Deselected, { color: colors_1.alloy, backgroundColor: backgroundColor })) : (react_1.default.createElement(radio_1.Deselected, { backgroundColor: backgroundColor }));
    }
    const disabledStyle = disabled ? { cursor: 'not-allowed', pointerEvents: 'none' } : {};
    return (react_1.default.createElement("div", { className: emotion_1.cx('checkbox', className), style: Object.assign(Object.assign({}, style), disabledStyle) },
        react_1.default.createElement("label", { className: emotion_1.cx('control-label', { 'text-muted': disabled }), htmlFor: inputId, style: Object.assign({ paddingLeft: 0 }, disabledStyle) },
            react_1.default.createElement("span", { style: { position: 'relative', top: '3px', paddingRight: '10px' } }, image),
            react_1.default.createElement("input", Object.assign({ id: inputId, name: name, type: "radio", disabled: disabled, checked: checked, value: value, onBlur: handleBlur, onFocus: handleFocus, onChange: handleChange, style: { opacity: 0, marginLeft: '-15px' } }, rest)),
            label)));
};
exports.default = Radio;
Radio.propTypes = {
    id: prop_types_1.default.string,
    name: prop_types_1.default.string,
    checked: prop_types_1.default.bool,
    label: prop_types_1.default.node,
    value: prop_types_1.default.any,
    disabled: prop_types_1.default.bool,
    whiteBackground: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    onCheck: prop_types_1.default.func,
    onBlur: prop_types_1.default.func,
    onFocus: prop_types_1.default.func,
    style: react_style_proptype_1.default,
};
Radio.displayName = exports.RADIO_NAME;
Radio.defaultProps = {
    disabled: false,
    className: '',
    whiteBackground: false,
};
